/*
 *
 *   reducer
 *
 */
import produce from "immer"
//import key from "./key"

import {
  CREATE_FOLLOW_RECORD_SUCCESS,
  CREATE_FOLLOW_RECORD_ERROR,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  COMPANY_META_DATA_SUCCESS,
  COMPANY_META_DATA_ERROR,
  LOAD_RECORDS_FOLLOW_HISTORY_RECORD_SUCCESS,
  LOAD_RECORDS_FOLLOW_HISTORY_RECORD_ERROR,
  UPDATE_FOLLOW_RECORD_SUCCESS,
  UPDATE_FOLLOW_RECORD_ERROR,
  LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD_SUCCESS,
  LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD_ERROR,
  UPLOAD_FOLLOW_ATTACHMENT_RECORD_SUCCESS,
  UPLOAD_FOLLOW_ATTACHMENT_RECORD_ERROR,
  FILE_UPLOAD_FOLLOW_ATTACHMENT_RECORD_SUCCESS,
  FILE_UPLOAD_FOLLOW_ATTACHMENT_RECORD_ERROR,
  LOAD_RECORDS_VALID_CACHE,
  ADD_REJECT_ERROR,
  ADD_REJECT_SUCCESS,
  LOAD_RECORDS_LEADCARRYFORWARDLIST_RECORD_SUCCESS,
  LOAD_RECORDS_LEADCARRYFORWARDLIST_RECORD_ERROR,
  LOAD_FOLLOWUP_HISTORY_SUCCESS,
  LOAD_FOLLOWUP_HISTORY_ERROR,
  LOAD_FOLLOWUP_DETAILS_CRON_SUCCESS,
  LOAD_FOLLOWUP_DETAILS_CRON_ERROR,
  LOAD_FOLLOWUP_DETAILS_SUCCESS,
  LOAD_FOLLOWUP_DETAILS_ERROR,
  LOAD_REJECT_REASON_LIST_SUCCESS,
  LOAD_REJECT_REASON_LIST_ERROR,
} from "./constants"

const initialState = {
  followupRecordsMetaData: [],
  companyMetaData: {},
  record: [],
  followupHistoryRecord: [],
  followup_history: [],
  followup_details: [],
  reject_reason: [],
  attachmentRecord: [],
  leadCarryForwardList: [],
  followup_cron_details: [],
  uploadRecord: [],
  fileUploadRecord: [],
  error: false,
  success: false,
  reject_Status: {},
}

export default function Reducer(
  state = initialState,
  {
    followupRecordsMetaData,
    companyMetaData,
    record,
    followupHistoryRecord,
    attachmentRecord,
    leadCarryForwardList,
    followup_cron_details,
    uploadRecord,
    fileUploadRecord,
    followup_history,
    type,
    error,
    success,
    followup_details,
    reject_reason,
    reject_Status,
  }
) {
  return produce(state, (draft) => {
    // console.log("followup_details draft", followup_details)
    // console.log("Switch type record_client_profile -->", record_client_profile)

    switch (type) {
      case CREATE_FOLLOW_RECORD_SUCCESS:
        draft.record = record
        draft.loading = false
        draft.error = error
        draft.success = success
        break
      case CREATE_FOLLOW_RECORD_ERROR:
        draft.loading = false
        draft.error = error
        draft.success = success
        break

      case UPDATE_FOLLOW_RECORD_SUCCESS:
        draft.record = record
        draft.loading = false
        draft.error = error
        draft.success = success
        break
      case ADD_REJECT_SUCCESS:
        draft.reject_Status = reject_Status
        draft.loading = false
        draft.error = error
        draft.success = success
        break
      case ADD_REJECT_ERROR:
      case UPDATE_FOLLOW_RECORD_ERROR:
        draft.loading = false
        draft.error = error
        draft.success = success
        break
      case LOAD_FOLLOWUP_DETAILS_CRON_SUCCESS:
        draft.followup_cron_details = followup_cron_details
        draft.loading = false
        draft.error = error
        draft.success = success
        break
      case LOAD_FOLLOWUP_DETAILS_SUCCESS:
        draft.followup_details = followup_details
        draft.loading = false
        draft.error = error
        draft.success = success
        break
      case LOAD_REJECT_REASON_LIST_SUCCESS:
        draft.reject_reason = reject_reason
        draft.loading = false
        draft.error = error
        draft.success = success
        break
      case LOAD_RECORDS_META_DATA_SUCCESS:
        draft.followupRecordsMetaData = followupRecordsMetaData
        draft.loading = false
        draft.error = error
        draft.success = success
        break
      case COMPANY_META_DATA_SUCCESS:
        draft.companyMetaData = companyMetaData
        draft.loading = false
        draft.error = error
        draft.success = success
        break

      case LOAD_RECORDS_META_DATA_ERROR:
      case COMPANY_META_DATA_ERROR:
        draft.loading = false
        draft.error = error
        draft.success = success
        break

      case LOAD_RECORDS_FOLLOW_HISTORY_RECORD_SUCCESS:
        draft.followupHistoryRecord = followupHistoryRecord
        draft.loading = false
        draft.error = error
        draft.success = success
        break
      case LOAD_FOLLOWUP_HISTORY_SUCCESS:
        draft.followup_history = followup_history
        draft.loading = false
        draft.error = error
        draft.success = success
        break

      case LOAD_RECORDS_FOLLOW_HISTORY_RECORD_ERROR:
        draft.loading = false
        draft.error = error
        draft.success = success
        break

      case LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD_SUCCESS:
        draft.attachmentRecord = attachmentRecord
        draft.loading = false
        draft.error = error
        draft.success = success
        break

      case LOAD_RECORDS_ATTACHMENT_DETAIL_RECORD_ERROR:
        draft.loading = false
        draft.error = error
        draft.success = success
        break

      case LOAD_RECORDS_LEADCARRYFORWARDLIST_RECORD_SUCCESS:
        draft.leadCarryForwardList = leadCarryForwardList
        draft.loading = false
        draft.error = error
        draft.success = success
        break

      case LOAD_RECORDS_LEADCARRYFORWARDLIST_RECORD_ERROR:
        draft.loading = false
        draft.error = error
        draft.success = success
        break

      case UPLOAD_FOLLOW_ATTACHMENT_RECORD_SUCCESS:
        draft.uploadRecord = uploadRecord
        draft.loading = false
        draft.error = error
        draft.success = success
        break

      case UPLOAD_FOLLOW_ATTACHMENT_RECORD_ERROR:
        draft.loading = false
        draft.error = error
        draft.success = success
        break

      case FILE_UPLOAD_FOLLOW_ATTACHMENT_RECORD_SUCCESS:
        draft.fileUploadRecord = fileUploadRecord
        draft.loading = false
        draft.error = error
        draft.success = success
        break

      case FILE_UPLOAD_FOLLOW_ATTACHMENT_RECORD_ERROR:
        draft.loading = false
        draft.error = error
        draft.success = success
        break

      case LOAD_RECORDS_VALID_CACHE:
      case LOAD_FOLLOWUP_DETAILS_ERROR:
      case LOAD_FOLLOWUP_HISTORY_ERROR:
      case LOAD_REJECT_REASON_LIST_ERROR:
      case LOAD_FOLLOWUP_DETAILS_CRON_ERROR:
        draft.loading = false
        draft.error = error
        draft.success = success
        break
    }
  })
}
